import { store } from '@grafana/data';

export default store;
